export enum EMicStatus {
  UNKNOWN = 'unknown',
  GRANTED = 'granted',
  DENIED = 'denied',
  NO_DEVICE = 'no-device',
  ERROR = 'error',
  PROMPT = 'prompt'
}

export enum EMicError {
  PERMISSION_DENIED = 'permission-denied',
  NO_DEVICE = 'no-device',
  GENERIC = 'generic-error'
}

export enum ECallButton {
  CALL_NOW = 'Call now',
  CALL_LATER = 'Call later',
  GET_MORE_MINUTES = 'Get more minutes',
  GET_CALL_MINUTES = 'Get call minutes'
}

export enum ECallStatus {
  CALLING = 'Calling',
  THINKING = 'Thinking',
  LISTENING = 'Listening',
  AI_READY = 'AI ready'
}
